/*
 * @file: index.js
 * @description: It Contain user related Action Creators.
 * @author: navreet
 */

import * as TYPE from '../constants'
import ApiClient from '../../api-client'
import { apiUrl, apiUrlBase, apiUrlMerchant } from '../../environment'
import { toastAction } from '../toast-actions'

export const is_fetching = (status) => ({ type: TYPE.IS_FETCHING, status })

export const logout_user = () => ({ type: TYPE.LOG_OUT })
export const merchant_list = (data, res) => ({ type: TYPE.MERCHANT_LIST, data, res })
export const featured_list = (data, res) => ({ type: TYPE.FEATURED_LIST, data, res })
export const featured_download_list = (data, res) => ({ type: TYPE.FEATURED_DOWNLOAD_LIST, data, res })
export const check_featured = (data, res) => ({ type: TYPE.FEATURED_STATUS, data, res })
export const merchant_profile = (data) => ({ type: TYPE.MERCHANT_PROFILE, data })
export const errorUpdate = (data, message) => ({ type: TYPE.ERROR_STATUS, data, message })
export const updateSelectedMerchantId = (data) => ({ type: TYPE.UPDATE_SELECTED_MERCHANT_ID, data })

//**** Thunk Action Creators For Api ****//
/****** action get listing ********/
export const userListing = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrlMerchant}/merchantList`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(merchant_list(response.data, response))
                // toastAction(true, response.message);
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}

/****** action creator to get merchant user profile ********/
export const getMerchantProfile = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrlBase}/merchant/merchantUserProfile`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(merchant_profile(response.data))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))
                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

/****** action creator for delete User ********/
export const deleteUsers = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.delete(`${apiUrlMerchant}/deleteMerchantsAccountbyID`, params, token).then(
            (response) => {
                if (response.customcode === 200) {
                    dispatch(is_fetching(false))
                    callback(true)
                } else if (response.customcode === 401) {
                    dispatch(logout_user())
                    dispatch(is_fetching(false))

                    callback(false)
                } else {
                    dispatch(is_fetching(false))
                    dispatch(errorUpdate(true, response.message))
                    callback(true)
                }
            },
        )
    }
}

/****** action creator for update User ********/
export const updateUserStatus = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrl}/adminUpdateUser`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(true)
            }
        })
    }
}

/****** action creator for add User ********/
export const addMerchant = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.post(`${apiUrlMerchant}/createMerchant`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}
/****** action creator for edit User ********/
export const editMerchant = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrlMerchant}/adminUpdateMerchant`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(is_fetching(false))
                dispatch(logout_user())
                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}
/****** action creator to check featured exist ********/
export const checkFeatured = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrlMerchant}/checkFeatured`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(check_featured(response.data))
                // console.log(response.data, 'response.data');
                // toastAction(true, response.message);
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))
                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}
/****** action creator to update featured ********/
export const updateFeatured = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.put(`${apiUrlMerchant}/update-featured`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(is_fetching(false))
                dispatch(logout_user())
                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}
/****** action get featured listing ********/
export const featuredListing = (params, callback) => {
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrlMerchant}/featured-history`, params, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(featured_list(response.data, response))
                // console.log(response.data, 'response.data');
                // toastAction(true, response.message);
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}
/****** action get all featured listing for download ********/
export const featuredListingDownload = (params, callback) => {
    const { page, limit, ...rest } = params;
    const newParams = { ...rest };
    return (dispatch, getState) => {
        const { token } = getState().user
        dispatch(is_fetching(true))
        ApiClient.get(`${apiUrlMerchant}/featured-history`, newParams, token).then((response) => {
            if (response.customcode === 200) {
                dispatch(is_fetching(false))
                dispatch(featured_download_list(response.data, response))
                // console.log(response.data, 'response.data');
                // toastAction(true, response.message);
                callback(true)
            } else if (response.customcode === 401) {
                dispatch(logout_user())
                dispatch(is_fetching(false))

                callback(false)
            } else {
                dispatch(is_fetching(false))
                dispatch(errorUpdate(true, response.message))
                callback(false)
            }
        })
    }
}
/****** action creator for logout ********/
export const logout = (token, callback) => {
    return (dispatch) => {
        //dispatch(is_fetching(true));
        //ApiClient.delete(`${apiUrl}/user/logout`, token).then(response => {
        //  if (response.statusCode === 200) {
        //    dispatch(is_fetching(false));
        dispatch(logout_user())
        callback(true)
        //  } else {
        //    dispatch(is_fetching(false));
        //    toastAction(false, response.msg);
        //    callback(true);
        //  }
        //});
    }
}
